import apiClient from "../../lib/apiClient";

export const userAPI = {
  // GET /api/users/:id
  getUser: async (id) => {
    try {
      const response = await apiClient.get(`/users/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || "Lấy thông tin người dùng thất bại",
      };
    }
  },

  // PUT /api/users/profile
  updateProfile: async (profileData) => {
    try {
      const response = await apiClient.put("/users/profile", profileData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Cập nhật profile thất bại",
      };
    }
  },

  // GET /api/users/stats
  getUserStats: async () => {
    try {
      const response = await apiClient.get("/users/stats");
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy thống kê thất bại",
      };
    }
  },

  // GET /api/users/count/non-admin
  getUserCount: async () => {
    try {
      const response = await apiClient.get("/users/count/non-admin");
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || "Lấy số lượng người dùng thất bại",
      };
    }
  },

  // ADMIN ONLY - GET /api/users/dashboard
  getDashboard: async () => {
    try {
      const response = await apiClient.get("/users/dashboard");
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy dashboard thất bại",
      };
    }
  },
};
